export const currencyFormatter = new Intl.NumberFormat('en-gb', {
    currency: 'gbp',
    style: 'currency',
    minimumFractionDigits: 0,
})